const VideoIcon = ({ mainColor, ...props }) => (
  <g fill="none" fill-rule="evenodd" {...props}>
    <path fill={mainColor} fill-rule="nonzero" d="M16.565 22.54L9 18v9.078" />
  </g>
)

export default VideoIcon



// WEBPACK FOOTER //
// ./svg/Video.js